import { createFileRoute } from '@tanstack/react-router'
import AgreementTransactions from 'Royalty/components/Agreement/AgreementTransactions'

export const Route = createFileRoute('/royalty_/agreement/$id/transactions')({
    component: AgreementTransactions,
})
